import styled from '@mui/system/styled';
import COLORS from '../../styles/Colors';

const StyledLink = styled('a', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})(({ color, disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  color: disabled ? COLORS.INACTIVE_LIGHT : color ?? COLORS.PRIMARY,
  pointerEvents: disabled ? 'none' : 'auto',
  textDecoration: disabled ? 'none' : 'underline',
  '&:hover': {
    color: disabled ? COLORS.INACTIVE_LIGHT : color ?? COLORS.PRIMARY,
  },
}));

export default StyledLink;
